import React from "react";
import { Pane, Dialog, Button } from "evergreen-ui";
import Component from "@reactions/component";
import Cookies from "universal-cookie";
import Host from "../../assets/js/Host";
import axios from "../../assets/js/AxiosInterceptors";
import { toast } from "react-toastify";
import SendIcon from "@mui/icons-material/Send";
import "react-datepicker/dist/react-datepicker.css";
import PersonIcon from "@mui/icons-material/Person";
import Lottie from "lottie-react-web";
 
import EditIcon from "@mui/icons-material/Edit";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import InputFiles from "react-input-files";
import moment from "moment";
import { Box, CircularProgress, Divider, IconButton } from "@mui/material";
import CustomTextField from "../../Components/CustomTextField";
import DeleteIcon from "@mui/icons-material/Delete";

// import moment from 'moment';
const cookies = new Cookies();

class Comments extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      spin: false,
      comments: [],
      comment: "",
      comment2: "",
      file: "",
      file2: "",
      spinComment: false,
    };
  }

  callcomm() {
    this.setState({ spin: true });
    var headers = {
      jwt: cookies.get("token"),
    };
    axios({
      url: Host + `comments/${this.props.id}`,
      method: "GET",
      headers: headers,
    })
      .then((response) => {
        // console.log('tok', response.data);
        this.setState({ comments: response.data.data, spin: false });
      })
      .catch((err) => {
        toast.error("Network Error");
      });
  }

  componentDidMount() {
    this.callcomm();
  }

  handleChange = (date) => {
    this.setState({
      startDate: date,
    });
  };

  addcomm() {
    let formData = new FormData();
    var headers = {
      jwt: cookies.get("token"),
    };
    if (this.state.comment.length === 0) {
      return toast.error("Add comment First");
    }
    this.setState({ spinComment: true });
    let commentsFiltered=this.state.comment?this.state.comment?.replace(/['"#@\/\\*&^%$]/g, ""):''
    let fdata = JSON.stringify({ comment: commentsFiltered });
    formData.append("photo", this.state.file);
    formData.append("params", fdata);
    axios({
      url: Host + `comments/comment/${this.props.id}`,
      method: "POST",
      headers: headers,
      data: formData,
    })
      .then((res) => {
        // console.log(response.data);
        if (res.data.status === true) {
          toast.success("Comment added successfully");
          this.callcomm();
          // const { onProfileDelete } = this.props.onProfileDelete
          // onProfileDelete()
          const { onRefTask } = this.props.onRefTask;
          onRefTask();
          this.setState({ comment: "", file: "", spinComment: false });
        } else if (res.data.status === false) {
          toast.error(res.data.data.message.text);
          this.setState({ comment: "", file: "", spinComment: false });
        }
      })
      .catch((err) => {
        toast.error("Network Error");
        // this.setState({ comment: "",file:'',spinComment:false })
      });
  }

  Delete(data) {
    // this.setState({ spinComment: true });
    var headers = {
      "Content-Type": "application/json",
      jwt: cookies.get("token"),
    };

    axios({
      url: Host + `comments/comment/${data}`,
      method: "DELETE",
      headers: headers,
    })
      .then((response) => {
        if (response.data.status === false) {
          toast.error(response.data.data.text);
          this.setState({ spinComment: false });
        } else if (response.data.status === true) {
          this.callcomm();
          const { onRefTask } = this.props.onRefTask;
          onRefTask();
          toast.success("deleted successfully");
          this.setState({ spinComment: false });
        }
      })
      .catch((err) => {
        toast.error("Network Error");
        this.setState({ spinComment: false });
      });
  }

  render() {
    return (
      <div>
        <Component initialState={{ isShown: false }}>
          <Pane>
            <div>
              {this.state.comments.length > 0 ? (
                <div
                  style={{
                    height: this.props?.commentHeight ? this.props?.commentHeight : 400,
                    width: "100%",
                    overflow: "auto",
                    backgroundColor: "#ffffff !important",
                  }}
                >
                  {this.state.comments.map((item, i) => (
                    <>
                      <div
                        key={i}
                        className={"comment_item"}
                        style={{
                           padding: "15px 25px", borderRadius: "0px",
                           backgroundColor:this.props?.cardColor?this.props?.cardColor:'#fff'
                         }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>
                            {" "}
                            <PersonIcon
                              style={{ fontSize: 15, color: "#7f7f7f" }}
                            />
                            {item.commenter_name}
                          </div>
                          <div>
                            {moment(item.comment_dateTime).format("LLL")}
                          </div>
                        </div>
                        <div
                          style={{
                            paddingTop: 14,
                            paddingBottom: 10,
                            textAlign: "start",
                            direction: "rtl",
                          }}
                        >
                          {item.comment_text.split("\n").map((i, n) => {
                            return <p key={n}>{i}</p>;
                          })}
                          {item.comment_pic_path === null ? null : (
                            <img
                              src={Host + item.comment_pic_path}
                              alt="img"
                              style={{ height: 100, cursor: "pointer" }}
                              onClick={() => {
                                window.open(
                                  Host + item.comment_pic_path,
                                  "_blank"
                                );
                              }}
                            />
                          )}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            padding: "5px",
                          }}
                        >
                          {JSON.parse(localStorage.getItem("roles")).includes(
                            13
                          ) ? (
                            <IconButton
                            onClick={() => {
                              if (window.confirm("Delete the Comment?")) {
                                this.Delete(item.comment_id);
                              }
                            }}
                            ><DeleteIcon/></IconButton>
                          ) : null}
                          <Component
                            initialState={{
                              isShown: false,
                              comment2: item.comment_text,
                            }}
                          >
                            {({ state, setState }) => (
                              <Pane>
                                <Dialog
                                  isShown={state.isShown}
                                  hasHeader={false}
                                  onCloseComplete={() =>
                                    setState({ isShown: false })
                                  }
                                  hasFooter={false}
                                  topOffset={200}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      display: "flex",
                                      alignItems: "start",
                                      justifyContent: "space-evenly",
                                      marginBottom: 5,
                                      marginTop: 5,
                                    }}
                                  >
                                    {/* TODO replace input file  */}
                                    {/* <InputFiles onChange={files =>
                                                                        this.setState({ file2: files[0], file: files.length })
                                                                    }>
                                                                        <AddPhotoAlternateIcon style={{ cursor: 'pointer', color: '#2e6b95' }} />
                                                                    </InputFiles> */}
                                    <CustomTextField
                                      label={"Comment"}
                                      haswidth={true}
                                      value={state.comment2}
                                      error={false}
                                      customWidth="100%"
                                      hasMultipleLine={true}
                                      // paddingHorizontal="2px 10px 2px 5px !important"
                                      message={""}
                                      readOnly={false}
                                      onChange={(e) => {
                                        setState({ comment2: e.target.value });
                                      }}
                                      onClearClick={() => {
                                        setState({ comment2: '' });

                                      }}
                                    />
                       
                                     <Box
                                       sx={{
                                        display:'flex',
                                        justifyContent:'center',
                                        alignItems:'center',
                                        backgroundColor:'#fff',
                                        boxShadow:'0 0 7px -2px #000',
                                        padding:'10px',
                                        marginTop:'3px',
                                        height:'55px',
                                        width:'55px'
                                       }}
                                      >
                                    <SendIcon
                                      id="com_icon"
                                      onClick={() => {
                                        var headers = {
                                          jwt: cookies.get("token"),
                                        };
                                        let formData = new FormData();
                                        if (state.comment2.length === 0) {
                                          return toast.error(
                                            "Add comment First"
                                          );
                                        }
                                        let fdata2 = JSON.stringify({
                                          comment: state.comment2,
                                        });
                                        formData.append(
                                          "photo",
                                          this.state.file2
                                        );
                                        formData.append("params", fdata2);
                                        axios({
                                          url:
                                            Host +
                                            `comments/comment/${item.comment_id}`,
                                          method: "PUT",
                                          headers: headers,
                                          data: formData,
                                        })
                                          .then((res) => {
                                            // console.log(response.data);
                                            if (res.data.status === true) {
                                              toast.success(
                                                "Comment updated successfully"
                                              );
                                              this.callcomm();
                                              const {
                                                onRefTask,
                                              } = this.props.onRefTask;
                                              onRefTask();
                                            } else if (
                                              res.data.status === false
                                            ) {
                                              toast.error(
                                                res.data.data.message.text
                                              );
                                            }
                                          })
                                          .catch((err) => {
                                            toast.error("Network Error");
                                          });
                                        setState({ isShown: false });
                                      }}
                                    />
                                    </Box>
                                  </div>
                                </Dialog>

                    
                                  <IconButton
                                    sx={{
                                      position:'relative',
                                        top:'4px'
                                    }}
                                    onClick={() => setState({ isShown: true })}
                                  >
                                  <EditIcon
                                    style={{
                                      fontSize: 20,
                                      color: "#22619f",
                                      cursor: "pointer",
                                    }}
                                  />
                                  </IconButton>
                              </Pane>
                            )}
                          </Component>
                        </div>
                      </div>
                      {/* <Divider style={{border:'1px dashed #f4f5ff',boxShadow:'none',margin:'auto',width:'90%',backgroundColor:'#f8f4ff'}}></Divider> */}
                    </>
                  ))}
                </div>
              ) : (
                <div
                  style={{
                    width: "100%",
                    height: this.props?.commentHeight?this.props?.commentHeight:200,
                    textAlign: "center",
                    color: "#000",
                    fontSize: 20,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <DeleteIcon sx={{ color: "#000" }} /> No Comments
                </div>
              )}

   

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-evenly",
                  marginBottom: 5,
                  marginTop: 10,
                }}
              >
                {/* <Box
                  sx={{
                    backgroundColor: "#fff",
                    width: "60px",
                    height: "55px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "2px",
                  }}
                >
                  <InputFiles
                    onChange={(files) =>
                      this.setState({ file: files[0], file1: files.length })
                    }
                  >
                    <AddPhotoAlternateIcon
                      style={{ cursor: "pointer", color: "#2e6b95" }}
                    />
                  </InputFiles>
                </Box> */}
                <CustomTextField
                  label={"comment"}
                  haswidth={true}
                  value={this.state.comment}
                  error={false}
                  customWidth="70%"
                  hasMultipleLine={true}
                  paddingHorizontal="2px 10px 2px 0px !important"
                  message={""}
                  readOnly={false}
                  onChange={(e) => {
                    this.setState({ comment: e.target.value });
                  }}
                  onClearClick={() => {
                    this.setState({ comment: "" });
                  }}
                />
       
                  <Box
                    sx={{
                      backgroundColor: "#fff",
                      width: "60px",
                      height: "55px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "2px",
                      marginTop: "2px",
                    }}
                  >
                  {this.state.spinComment === true ? <CircularProgress />
                    :<SendIcon
                      id="com_icon"
                      onClick={() => {
                        this.addcomm();
                      }}
                    />}
                  </Box>
                
              </div>
            </div>
            {/* </Dialog> */}
          </Pane>
        </Component>
      </div>
    );
  }
}
export default Comments;
